module.exports = __webpack_public_path__ + "static/media/new-message-bro.04b4f037.svg";